<script>
import ModalDialog from './ModalDialog.vue'
import SuccessText from '../Text/SuccessText.vue'

export default {
  components: { SuccessText, ModalDialog },
  props: {
    id: {
      type: String,
      required: true,
    },
    success: {
      type: String,
      required: true,
    },
  },
  methods: {
    open() {
      this.$refs['modal'].open()
    },
    close() {
      this.$refs['modal'].close(false)
    },
  },
}
</script>
<template>
  <ModalDialog
    ref="modal"
    :id="id"
    class-content="bg-pale-success"
    :show-header="false"
    :close-button-in-title="false"
    :close-button-in-content="true"
    e2e-modal="success"
  >
    <SuccessText>
      <span>{{ success }}</span>
    </SuccessText>
  </ModalDialog>
</template>
